import { Entity } from '@api/api/entity-schema';

import styles from './ThemeExposureTab.module.scss';
import { ThemeExposureTable } from './theme-exposure-table/ThemeExposureTable';

export interface ThemeExposureTabProps {
  entity: Entity;
}

export const ThemeExposureTab = ({ entity }: ThemeExposureTabProps) => {
  return (
    <div className={styles.root} data-testid="theme-exposure-tab">
      <div className={styles.tabContent}>
        <ThemeExposureTable entity={entity} />
      </div>
    </div>
  );
};
